import script from "./gerenzhongxinnav.vue?vue&type=script&setup=true&lang=js"
export * from "./gerenzhongxinnav.vue?vue&type=script&setup=true&lang=js"

import "./gerenzhongxinnav.vue?vue&type=style&index=0&id=79ef5a60&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ef5a60"]])

export default __exports__